export function getAppDownloadPlatform(device = {}) {
  const userAgent = String(device.userAgent || '')
  if (/iPhone|iPad|iPod/i.test(userAgent)
    || (device.platform === 'MacIntel' && device.maxTouchPoints > 1)) {
    return 'ios'
  }
  return /Android/i.test(userAgent) ? 'android' : ''
}

export function resolveSuccessAppDownloadUrl(config = {}, platform = '', origin) {
  const platformUrl = platform === 'ios'
    ? config.successAppIosDownloadUrl
    : platform === 'android' ? config.successAppAndroidDownloadUrl : ''
  const downloadUrl = [platformUrl, config.successAppDownloadUrl, config.appDownloadUrl]
    .find(value => typeof value === 'string' && value.trim())
  if (!downloadUrl)
    return ''

  try {
    const url = new URL(downloadUrl.trim(), origin)
    return ['http:', 'https:'].includes(url.protocol) ? url.href : ''
  }
  catch {
    return ''
  }
}

export const APP_ORDER_SYNC_DISCOUNT = 80
export const APP_ORDER_SYNC_DURATION_MS = 2 * 60 * 60 * 1000

// 暫以關閉折扣碼的台灣店鋪作為 App 優惠推廣範圍；配置未載入時不顯示。
export function shouldShowAppOrderSyncPromotion(config, templateKey) {
  if (templateKey !== 'default') return false
  const value = config?.showDiscountCode
  return value === false || value === 0
    || (typeof value === 'string' && ['false', '0'].includes(value.trim().toLowerCase()))
}

function firstPaymentCode(source = {}) {
  for (const key of ['payOrderCode', 'payOrderNo', 'merchantOrderNo']) {
    const value = Array.isArray(source?.[key]) ? source[key][0] : source?.[key]
    if (typeof value === 'string' && value.trim()) return value.trim()
    if (typeof value === 'number' && Number.isFinite(value)) return String(value)
  }
  return ''
}

// 商城訂單可能拆單；App 同步必須使用整筆支付單號。
export function resolveAppSyncPaymentCode(orderInfo = {}, query = {}) {
  return firstPaymentCode(query)
    || firstPaymentCode(orderInfo)
    || firstPaymentCode(orderInfo.payOrderInfo)
    || firstPaymentCode(orderInfo.paymentSuccessResponse)
    || firstPaymentCode(orderInfo.createOrderResponse)
}

export function parseOrderCreationTime(value) {
  if (value === null || value === undefined || value === '') return null
  if (typeof value !== 'number' && typeof value !== 'string') return null
  const text = String(value).trim()
  if (!text) return null
  if (/^\d+(\.\d+)?$/.test(text)) {
    const timestamp = Number(text)
    return timestamp > 0 && Number.isFinite(timestamp)
      ? (timestamp < 1e12 ? timestamp * 1000 : timestamp)
      : null
  }
  // 接口的無時區日期按台灣時間處理，也兼容 Safari。
  const normalized = text.replace(/^(\d{4})\/(\d{2})\/(\d{2})/, '$1-$2-$3').replace(' ', 'T')
  const localDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(normalized)
  const timestamp = Date.parse(localDate ? `${normalized}+08:00` : normalized)
  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null
}

export function resolveAppSyncDeadline(orderInfo = {}, fallbackStartedAt = Date.now()) {
  const sources = [orderInfo.payOrderInfo, orderInfo.paymentSuccessResponse, orderInfo, orderInfo.createOrderResponse,
    orderInfo.mallOrderDTOList?.[0], orderInfo.createOrderResponse?.mallOrderDTOList?.[0]]
  for (const source of sources) {
    const createdAt = parseOrderCreationTime(source?.createTime)
    if (createdAt !== null) return createdAt + APP_ORDER_SYNC_DURATION_MS
  }
  return fallbackStartedAt + APP_ORDER_SYNC_DURATION_MS
}

export function formatAppSyncCountdown(deadline, now = Date.now()) {
  const seconds = Math.max(0, Math.ceil((deadline - now) / 1000))
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(value => String(value).padStart(2, '0')).join(':')
}
